import React from 'react';
import styled from 'styled-components';
import theme, { textBold } from 'theme/theme';

const EnvironmentIndicator = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;
  padding: 5px 10px;
  font-size: ${theme.fontSizes.small};
  text-transform: uppercase;
  ${textBold};
  letter-spacing: 1px;
  background: ${theme.colors.primary};
  color: #fff;
  box-shadow: ${theme.shadows.default};
`;

export default () => (
  process.env.REACT_APP_ENVIRONMENT
    ? <EnvironmentIndicator>{process.env.REACT_APP_ENVIRONMENT}</EnvironmentIndicator>
    : ''
);
